const cards = [
    {
        id: '1_Muybridge',
        image: `${window.rootUrl}/img/inspirationBoard/1_Muybridge.webp`,
        position: {
            mobile: {
                width: 322,
                height: 200,
                top: 0,
                left: 100,
            },
            desktop: {
                width: 322,
                height: 240,
                top: 60,
                left: 400,
            },
        },
        title: 'Eadweard Muybridge',
        copy: (
            <>
                <p>
                    Sol’s interest in seriality was influenced by his
                    photography book about 19th century English photographer
                    Eadweard Muybridge—a stop-motion photographer best known for
                    his pictures of animals in motion. He contributed many
                    technical advances to photography, including better lenses
                    and faster shutter speeds.
                </p>
                <p>
                    “I was fascinated with the idea of a still movie; it was a
                    pre-movie movie. I always was trying to incorporate this
                    into making art,” said Sol.
                </p>
            </>
        ),
    },

    {
        id: 'Pyramid',
        image: `${window.rootUrl}/img/inspirationBoard/2_Pyramid.webp`,
        position: {
            mobile: {
                width: 248,
                height: 200,
                top: 0,
                left: -50,
            },
            desktop: {
                width: 248,
                height: 200,
                top: 702,
                left: 601,
            },
        },
        title: 'Pyramid',
        copy: (
            <>
                <p>
                    In 1966 Sol published “Ziggurats: Liberating Set-backs to
                    Architectural Fashion,” in Arts Magazine. In the article, he
                    discusses the ziggurat-style buildings built in New York
                    between 1916 and 1963. He commented on restrictive
                    parameters, or building codes, and how they necessitated
                    design that liberated the form. This created buildings that
                    were, in his estimation, “valuable works of art.” Sol
                    noticed the same when looking at the pyramids of Egypt.
                </p>
            </>
        ),
    },

    {
        id: 'Hanne Darboven',
        image: `${window.rootUrl}/img/inspirationBoard/3_Darboven.webp`,
        position: {
            mobile: {
                width: 198,
                height: 282,
                top: 0,
                left: 20,
            },
            desktop: {
                width: 198,
                height: 282,
                top: 360,
                left: 502,
            },
        },
        title: 'Hanne Darboven',
        copy: (
            <>
                <p>
                    Sol met artist Hanne Darboven in New York in 1966. He was a
                    champion of her work. They became penpals after she left New
                    York for her native Germany. Hanne would send Sol numbers,
                    scribbles, and musical notes, sometimes photos of her dolls
                    and toys, her home, her pets, and her mother. She’d mail Sol
                    vintage toys, which still adorn Sol’s studio. They wrote to
                    each other for almost forty years.
                </p>
            </>
        ),
    },

    {
        id: '4_Hanne_and_goat',
        image: `${window.rootUrl}/img/inspirationBoard/4_Hanne_and_goat.webp`,
        position: {
            mobile: {
                width: 200,
                height: 272,
                top: 0,
                left: 50,
            },
            desktop: {
                width: 200,
                height: 272,
                top: 200,
                left: 800,
            },
        },
        title: 'Hanne Darboven’s goat Mickey',
        copy: (
            <>
                <p>
                    Hanne Darboven was a lifelong friend to Sol. Of her, Sol
                    said, “The architecture of time. Endless, remorseless,
                    infinite. As fast as the oceans, as short as a wave. It
                    includes...all of our lifetimes, and more days, months,
                    centuries. The remote past the remote future and now. As
                    simple as a line on paper, as complex as a thousand pages.
                    The scope and elegance of her work and thinking is something
                    one never forgets.”
                </p>
            </>
        ),
    },

    {
        id: '5_Pat_Steir',
        image: `${window.rootUrl}/img/inspirationBoard/5_Pat_Steir.webp`,
        position: {
            mobile: {
                width: 265,
                height: 200,
                top: 0,
                left: -20,
            },
            desktop: {
                width: 265,
                height: 200,
                top: 300,
                left: 100,
            },
        },
        title: 'Pat Steir, <em>Buddha in Cave Waterfall</em>',
        copy: (
            <>
                <p>
                    Sol and artist Pat Steir met in the early 1970s and enjoyed
                    a long friendship. (Pictured: Steir&apos;s{' '}
                    <em>Buddha in the Cave Waterfall</em>, 2001-2002) Sol had
                    never learned to drive, so Pat drove him around Europe
                    between their art exhibitions. They met others during this
                    time, like gallerist Marilena Bonomo, and made many great
                    friends.
                </p>
            </>
        ),
    },

    {
        id: '6_Pat_Steir',
        image: `${window.rootUrl}/img/inspirationBoard/6_Pat_Steir.webp`,
        position: {
            mobile: {
                width: 300,
                height: 223,
                top: 0,
                left: 80,
            },
            desktop: {
                width: 300,
                height: 223,
                top: 177,
                left: 1300,
            },
        },
        title: 'Pat Steir, <em>Waterfall of the Asian Night</em>',
        copy: (
            <>
                <p>
                    Sol and artist Pat Steir gifted and traded works over the
                    years. Her work is an important part of his collection.
                    (Pictured: <em>Waterfall of the Asian Night</em>, 1990)
                </p>
            </>
        ),
    },

    {
        id: '7_Design_small_poster',
        image: `${window.rootUrl}/img/inspirationBoard/7_Design_small_poster.webp`,
        position: {
            mobile: {
                width: 196,
                height: 255,
                top: 0,
                left: 120,
            },
            desktop: {
                width: 196,
                height: 255,
                top: 72,
                left: 1702,
            },
        },
        title: 'Design Work',
        copy: (
            <>
                <p>
                    “My aesthetic comes from the Bauhaus and the Russian
                    Suprematists, and I see art also as being practical,” Sol
                    said in an interview with Architectural Digest. Using tools
                    like a ruler, triangle, and compass from his days as a
                    graphic designer, Sol created layouts of his exhibitions. He
                    also designed the accompanying posters, announcements, and
                    catalogues.
                </p>
            </>
        ),
    },

    {
        id: '8_Guilio_Paolini',
        image: `${window.rootUrl}/img/inspirationBoard/8_Guilio_Paolini.webp`,
        position: {
            mobile: {
                width: 139,
                height: 100,
                top: 0,
                left: 30,
            },
            desktop: {
                width: 139,
                height: 100,
                top: 251,
                left: 1034,
            },
        },
        title: 'Giulio Paolini, <em>Mimesi</em>',
        copy: (
            <>
                <p>
                    Italian Arte Povera artist Giulio Paolini first met Sol in
                    the 1970s in Spoleto, Italy. Guilio had been a great admirer
                    of Sol&apos;s work since the 1960s. According to Paolini:
                    “Our conversation was difficult (I do not speak English) but
                    sincere and—I like to think—meaningful for both of us.
                    Mutual exchanges of gifts, postcards, visits to each
                    other&apos;s exhibitions, were evidence of a reciprocal
                    esteem that bound us together sincerely.” Pictured: A
                    snapshot of an installation of Guiolio Paolini&apos;s
                    <em>Mimesi</em>, 1976. [Date of photograph unknown].
                </p>
            </>
        ),
    },

    {
        id: '9_Kiki_Smith',
        image: `${window.rootUrl}/img/inspirationBoard/9_Kiki_Smith.webp`,
        position: {
            mobile: {
                width: 200,
                height: 265,
                top: 0,
                left: 100,
            },
            desktop: {
                width: 200,
                height: 265,
                top: 674,
                left: 1600,
            },
        },
        title: 'Kiki Smith',
        copy: (
            <>
                <p>
                    Artist Kiki Smith first met Sol when she visited his house
                    in Connecticut in 1990. He’d bought a sculpture of hers and
                    invited her to oversee the installation. The sculpture was a
                    cast of her mother’s head with very long hair to symbolize
                    the wisdom of a full life. After this time, he kept in
                    regular contact through postcards. Pictured: Kiki Smith,
                    photographed by Steven Klein, New York, 1995 on an
                    invitation for her exhibition: Kiki Smith at Kukje Gallery,
                    Seoul
                </p>
            </>
        ),
    },

    {
        id: '10_Louise',
        image: `${window.rootUrl}/img/inspirationBoard/10_Louise.webp`,
        position: {
            mobile: {
                width: 183,
                height: 98,
                top: 40,
                left: 120,
            },
            desktop: {
                width: 183,
                height: 98,
                top: 452,
                left: 1500,
            },
        },
        title: 'Louise Lawler',
        copy: (
            <>
                <p>
                    Sol met artist Louise Lawler in the 1970s. Lawler had her
                    first solo museum exhibition “Home/Museum Arranged for
                    Living and Viewing,”at the Wadsworth Atheneum in Hartford,
                    Connecticut, in 1984. She borrowed Sol’s works to display
                    alongside hers for the exhibition. Pictured: Invitation for
                    Louise Lawler Exhibition at Sprengel Museum Hannover, 1994.
                </p>
            </>
        ),
    },

    {
        id: '11_Ursula',
        image: `${window.rootUrl}/img/inspirationBoard/11_Ursula.webp`,
        position: {
            mobile: {
                width: 250,
                height: 200,
                top: 0,
                left: 1202,
            },
            desktop: {
                width: 250,
                height: 200,
                top: 600,
                left: 1202,
            },
        },
        title: 'Ursula von Rydingsvard',
        copy: (
            <>
                <p>
                    Sol met artist Ursula von Rydingsvard early in her career
                    and they became great friends, trading artworks often and
                    maintaining a deep mutual respect. Many of Ursula’s enormous
                    sculptures are made of cedar beams she cuts with a saw,
                    stacks, and glues in a grid. She attributes her use of the
                    grid to Sol. Pictured: Ursula von Rydingsvard,{' '}
                    <em>Lace Mountains</em>, 1989, cedar and graphite.
                </p>
            </>
        ),
    },

    {
        id: '12_Petah_Coyne',
        image: `${window.rootUrl}/img/inspirationBoard/12_Petah_Coyne.webp`,
        position: {
            mobile: {
                width: 198,
                height: 252,
                top: 0,
                left: 40,
            },
            desktop: {
                width: 198,
                height: 252,
                top: 600,
                left: 40,
            },
        },
        title: 'Petah Coyne',
        copy: (
            <>
                <p>
                    Petah Coyne is a contemporary American sculptor and
                    photographer best known for her large- and small-scale
                    hanging sculptures and floor installations. She traded this
                    work with Sol, now seen in the collection of the National
                    Gallery of Art in Washington D.C. This ethereal piece is
                    made of wax, steel, wire, barbed wire, peacock feathers,
                    plastic and silk. Pictured:{' '}
                    <em>Untitled #807 (Miss Haversham)</em>, 1995.
                </p>
            </>
        ),
    },

    {
        id: '13_Roxy_Paine',
        image: `${window.rootUrl}/img/inspirationBoard/13_Roxy_Paine.webp`,
        position: {
            mobile: {
                width: 143,
                height: 213,
                top: 0,
                left: 29,
            },
            desktop: {
                width: 143,
                height: 213,
                top: 49,
                left: 29,
            },
        },
        title: 'Roxy Paine',
        copy: (
            <>
                <p>
                    Roxy Paine is an American painter and sculptor known for his
                    installations that evoke elements of conflict between the
                    natural world and the artificial creations of humanity.
                    Pictured: Roxy Paine, <em>Untitled</em>, 2005.{' '}
                    <em>Invitation to Sculpture</em> at James Cohan Gallery, New
                    York, 2005.
                </p>
            </>
        ),
    },

    {
        id: '14_Pigozzi',
        image: `${window.rootUrl}/img/inspirationBoard/14_Pigozzi.webp`,
        position: {
            mobile: {
                width: 239,
                height: 182,
                top: 0,
                left: 300,
            },
            desktop: {
                width: 239,
                height: 182,
                top: 802,
                left: 300,
            },
        },
        title: 'Jean Pigozzi',
        copy: (
            <>
                <p>
                    Sol traveled to China in 1980, right after American tourists
                    were allowed to return. He was joined by photographer Jean
                    Pigozzi and several others. Sol and Jean became instant
                    friends, bonding over a Sony Walkman Jean had brought with
                    him. Sol had never seen one. He got his own and began
                    copying his records onto tapes.
                </p>
            </>
        ),
    },

    {
        id: '16_Watanabe_Studios',
        image: `${window.rootUrl}/img/inspirationBoard/16_Watanabe_Studios.webp`,
        position: {
            mobile: {
                width: 205,
                height: 144,
                top: 0,
                left: 898,
            },
            desktop: {
                width: 205,
                height: 144,
                top: 830,
                left: 898,
            },
        },
        title: 'Thanks from the Team!',
        copy: (
            <>
                <p>
                    Sol had fabricators rendering his structures in metal
                    beginning in 1965. His studio assistants thanked him for the
                    drawings he gave them with this special note.
                </p>
            </>
        ),
    },

    {
        id: '17_Watanabe_Studios',
        image: `${window.rootUrl}/img/inspirationBoard/17_Watanabe_Studios.webp`,
        position: {
            mobile: {
                width: 102,
                height: 70,
                top: 0,
                left: 1052,
            },
            desktop: {
                width: 153,
                height: 105,
                top: 573,
                left: 924,
            },
        },
        title: 'Thanks from the Team (B Side)',
        copy: (
            <>
                <p>
                    Sol was thankful for the precision his fabricators and
                    drafters were able to achieve. He would give them drawings,
                    mostly gouaches, to thank them for their hard work.
                    Pictured: The back of a thank you card sent to Sol from his
                    studio assistants.
                </p>
            </>
        ),
    },

    {
        id: '18_Roy_Villevoye',
        image: `${window.rootUrl}/img/inspirationBoard/18_Roy_Villevoye.webp`,
        position: {
            mobile: {
                width: 252,
                height: 199,
                top: 0,
                left: 1719,
            },
            desktop: {
                width: 252,
                height: 199,
                top: 401,
                left: 1719,
            },
        },
        title: 'Fransje and Roy Villevoye',
        copy: (
            <>
                <p>
                    Sol formed valuable friendships with many of his drafters.
                    Pictured here: A wedding photograph of Fransje and Roy
                    Villevoye—a husband-and-wife team who drafted his wall
                    drawings.
                </p>
            </>
        ),
    },

    {
        id: '19_Note',
        image: `${window.rootUrl}/img/inspirationBoard/19_Note.webp`,
        position: {
            mobile: {
                width: 100,
                height: 187,
                top: 0,
                left: 1151,
            },
            desktop: {
                width: 100,
                height: 187,
                top: 378,
                left: 1151,
            },
        },
        title: 'Happy Holidays',
        copy: (
            <>
                <p>
                    Notecards with messages from friends were important to Sol.
                    Pictured: Holiday card from Ralph and Kay Iwamoto
                </p>
            </>
        ),
    },

    {
        id: '20_Get_Well',
        image: `${window.rootUrl}/img/inspirationBoard/20_Get_Well.webp`,
        position: {
            mobile: {
                width: 101,
                height: 155,
                top: 0,
                left: 1100,
            },
            desktop: {
                width: 101,
                height: 155,
                top: 45,
                left: 1100,
            },
        },
        title: 'Get well soon',
        copy: (
            <>
                <p>
                    Connecticut artist Cary Smith was one of Sol’s great
                    friends. His personal touch on a get well note to Sol
                    reflected the bold color application of his abstract
                    paintings. Pictured here: A get well note from artist.
                </p>
            </>
        ),
    },
];

export default cards;
